import { observable, IObservableArray, action } from "mobx";
import SeekerStore from "./seekerStore";
import { CourseOffering } from "../models/education";
import { BusyEvent } from "../models/enums";
import Fetcher from "../utils/fetcher";
import { copyArray } from "../utils/data";
import { LearnedSkill } from "../models/opportunity";

export default class EducationsStore {
  private _store: SeekerStore;
  @observable courses: Array<CourseOffering>;

  constructor(store: SeekerStore) {
    this._store = store;
    this.courses = new Array<CourseOffering>();
  }
  getCoursesForOpportunity = (opId: string): void => {
    this._store.viewState.setBusyBit(BusyEvent.LoadCourses);
    Fetcher.get(`api/ed/courses/suggestions?opportunity=${opId}`, action((courses: Array<CourseOffering>): void => {
      copyArray(courses, this.courses, (c: CourseOffering) => { return new CourseOffering(c); });
      this._store.viewState.clearBusyBit(BusyEvent.LoadCourses);
    }));
  }
  @action clear(): void {
    this.courses = new Array<CourseOffering>();
  }

  courseMatch = (id: string): boolean => {
    let flag: boolean = false;
    this.courses.map((c: CourseOffering): void => {
      c.skills.map((skill: LearnedSkill, i: number): void => {
        if (skill.skillId === id) {
          flag = true;
        }
      });
    })
    return flag;
  }
}


// WEBPACK FOOTER //
// ./src/stores/educationsStore.ts